import {
    createVoicePreferences,
    DEFAULT_VOICE_VOLUME,
    NO_AUDIO_DEVICES,
    type IAudioDevices,
    type IChosenAudioDevice,
    type IVoicePreferences,
    type IVoicePreferenceStore,
    type IVoiceVolume,
} from '@srm/screen-sharing/light';

/**
 * Звук показа у пользователя (IMPLEMENTATION.md §42): ключи `srm.screenShare.voiceInput`, `.voiceOutput`,
 * `.noiseSuppression`, `.voiceVolumes` — рядом с выключателем звуков сеанса `srm.screenShare.cues`.
 */
export const SUPPORT_VOICE_NAMESPACE = 'srm.screenShare';

let preferences: IVoicePreferenceStore | null = null;
/** Микрофон, динамики, шумоподавление и громкость специалистов по их пользователю — одни на все показы. */
export const supportVoicePreferences = (): IVoicePreferenceStore =>
    (preferences ??= createVoicePreferences(SUPPORT_VOICE_NAMESPACE));

/** Меню микрофона и громкость специалистов в полосе показа. */
export interface ISupportSound {
    prefs: IVoicePreferences;
    devices: IAudioDevices;
    /** Браузер умеет выбирать динамики и назвал хоть одни. */
    outputSelectable: boolean;
    chooseInput: (device: IChosenAudioDevice | null) => void;
    chooseOutput: (device: IChosenAudioDevice | null) => void;
    setNoiseSuppression: (on: boolean) => void;
    volumeOf: (userId: string | undefined) => IVoiceVolume;
    setVolume: (userId: string, change: Partial<IVoiceVolume>) => void;
}

const noop = () => undefined;

/** Без провайдера (стори, тесты частей оболочки): выбор по умолчанию, изменения никуда не идут. */
export const inertSupportSound: ISupportSound = {
    prefs: { input: null, output: null, noiseSuppression: true, volumes: {} },
    devices: NO_AUDIO_DEVICES,
    outputSelectable: false,
    chooseInput: noop,
    chooseOutput: noop,
    setNoiseSuppression: noop,
    volumeOf: () => DEFAULT_VOICE_VOLUME,
    setVolume: noop,
};
